export default "__VITE_ASSET__2c6994d1__"